import React from 'react'
import styled from '@emotion/styled'
import {TitleGradientHome} from '../title'
import LogoBnp from '../../images/logo_bnp.inline.svg'
import LogoVinci from '../../images/logo_vinci.inline.svg'
import LogoSuez from '../../images/logo_suez.inline.svg'
import LogoLoreal from '../../images/logo_loreal.inline.svg'
import LogoAphp from '../../images/logo_aphp.inline.svg'
import {device} from '../../devices'

export const TheyTrustUs = ({intl}) => (
  <Global>
    <TitleGradientHome>
      {intl.formatMessage({id: 'software_page.they_trust_us_title'})}
    </TitleGradientHome>
    <div>
      <LogoBnp data-sal="slide-up" data-sal-duration="200" data-sal-easing="ease"/>
      <LogoVinci data-sal="slide-up" data-sal-duration="300" data-sal-easing="ease"/>
      <LogoSuez data-sal="slide-up" data-sal-duration="400" data-sal-easing="ease"/>
      <LogoLoreal data-sal="slide-up" data-sal-duration="500" data-sal-easing="ease"/>
      <LogoAphp data-sal="slide-up" data-sal-duration="600" data-sal-easing="ease"/>
    </div>
  </Global>
)

const Global = styled.div`
  width: 100vw;
  height: 27.344vw;
  background-color: ${({theme: {whitegrey}}) => whitegrey};
  display: flex;
  align-items: center;
  justify-content:flex-start;
  flex-direction: column;
  margin-top: 6vw;
  
  h2 {
    margin: 6vw 0;
  }
 
  svg, path {
    fill: #001a30;
  }
  
  div {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    
    svg {
      height: auto;
      width: 10vw;
      
      @media ${device.mobileL} {
        width: 35%;
        margin: 20px 0;
      }
    }
    
    @media ${device.mobileL} {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-evenly;
    }
  }
  @media ${device.mobileL} {
      margin-top: 17vw;
      height: auto;
      padding: 50px 0;
  }
`
